<template>
  <div class="bank-details">
    <div class="form">
      <div class="r-text-intro">פרטי חשבון בנק</div>

      <div class="r-text-headline-paragraph">
        צריך אותם כדי ש׳מיטב׳
        יוכלו ליצור את הוראת הקבע
        מול הבנק.
      </div>

      <div class="r-form">
        <div class="row no-wrap q-gutter-md r-form-row">
          <default-autocomplete
            :value="bank"
            :options="banks"
            label="בנק"
            validations="required"
            autofocus
            class="col-7"
            @observe="observe"
            @input="setBankAndJump">
            <template #option="scope">
              <bank-option :bank-name="scope.opt.label" :bank-number="scope.opt.value" :scope="scope"/>
            </template>
          </default-autocomplete>
          <default-text-input
            ref="bankBranch"
            :value="bankBranch"
            type="tel"
            label="סניף"
            validations="required|numeric|max:5"
            @observe="observe"
            @input="setBankBranch"
          />
        </div>
        <div class="r-form-row">
          <default-text-input
            :value="accountNumber"
            type="tel"
            label="מספר חשבון"
            validations="required|numeric|max:20"
            class="full-width"
            @input="setAccountNumber"
            @observe="observe"
            append-icon="https"
          />
        </div>

        <div class="r-form-row">
          <default-text-input
            :value="bankAccountOwner"
            label="חשבון הבנק בבעלות של"
            validations="required|nameCharacters|max:100"
            class="full-width"
            @observe="observe"
            @input="setBankAccountOwner"
          />
        </div>

      </div>

    </div>

    <default-button label="אישור הפקדה וסיימנו!" @click="complete" :disable="locked" :loading="locked"/>
  </div>
</template>

<script>
import WizardPage from '@/mixins/WizardPage';
import { mapState, mapMutations } from 'vuex';
import Banks from '@/data/Banks';
import BankOption from '@/components/meitav-dash/open-fund/BankOption';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import DefaultAutocomplete from '@/components/styled/DefaultAutocomplete';

export default {
  name: 'Payment',
  components: { DefaultAutocomplete, DefaultTextInput, DefaultButton, BankOption },
  mixins: [WizardPage, Banks],
  created() {
    if (!this.bankAccountOwner) {
      this.setBankAccountOwner(`${this.firstName} ${this.lastName}`);
    }
  },
  computed: {
    ...mapState('meitavDash/openFund', ['bank', 'bankBranch', 'accountNumber', 'bankAccountOwner', 'firstName', 'lastName']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setBank', 'setBankBranch', 'setAccountNumber', 'setBankAccountOwner']),
    setBankAndJump(bank) {
      this.setBank(bank);
      this.$refs.bankBranch.focus();
    },
  },
};
</script>
